import { render, staticRenderFns } from "./topGameMenuList.vue?vue&type=template&id=06a44b07&scoped=true&"
import script from "./topGameMenuList.vue?vue&type=script&lang=js&"
export * from "./topGameMenuList.vue?vue&type=script&lang=js&"
import style0 from "./topGameMenuList.vue?vue&type=style&index=0&id=06a44b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a44b07",
  null
  
)

export default component.exports